import $ from 'jquery';

function Slider(){
    // selectors
    var boxAvis = $('.box.avis');
    var avisContainer = boxAvis.find('.avis-container');
    var prev = avisContainer.find(".prev");
    var next = avisContainer.find(".next");
    var slider = avisContainer.find('.slider');
    var slide = slider.find('.slide');
    var numberOfSlides = slide.length;
    var slidesPosition = 0;
    

    // events
    next.on('click', nextSlide);
    prev.on('click', prevSlide);

    function nextSlide(){
        if(slidesPosition < numberOfSlides - 1){
            slidesPosition++;
            // console.log(slidesPosition)
            slider.animate({marginLeft:"-"+ 100 * slidesPosition +"%"},200);
            if(slidesPosition == numberOfSlides - 1){
                next.addClass('disabled');
            }
            if(slidesPosition == 1){
                prev.removeClass('disabled');
            }
        }
    }

    function prevSlide(){
        if(slidesPosition > 0){
            if(numberOfSlides == 2){
                next.removeClass('disabled');
                prev.addClass('disabled');
                slidesPosition--;
                slider.animate({marginLeft:"-"+ 100 * slidesPosition +"%"},200);
            }else{
                slidesPosition--;
                slider.animate({marginLeft:"-"+ 100 * slidesPosition +"%"},200);
                if(slidesPosition == 0){
                    prev.addClass('disabled');
                }
                if(slidesPosition == numberOfSlides - 2){
                    next.removeClass('disabled');
                }
            }
        }
    }
}

export default Slider;